import { combineReducers } from '@reduxjs/toolkit';

import apiConsumer from './api-consumer';
import assignedMembership from './assigned-membership';
import assignedPermissions from './assigned-permissions';
import auth from './auth';
import bankid from './bankid';
import blockedPermissions from './blocked-permissions';
import branchAdmin from './branch-admin';
import assignmentOptions from './branch-assignment-options';
import branchConnections from './branch-connections';
import branchUsers from './branch-users';
import branches from './branches';
import cloudEvents from './cloud-events';
import facets from './facets';
import importsettings from './import-settings';
import manufacturers from './manufacturers';
import memberships from './memberships';
import pdfTemplate from './pdf-template';
import permissionLookup from './permission-lookup';
import resellerFor from './reseller-for';
import settablePermissions from './settable-permissions';
import socialBoost from './social-boost';
import synonymVehicle from './synonym-vehicle';
import systemClients from './system-clients';

const rootReducer = combineReducers({
  auth,
  bankid,
  branches,
  branchAdmin,
  branchConnections,
  branchUsers,
  facets,
  synonymVehicle,
  importsettings,
  resellerFor,
  manufacturers,
  apiConsumer,
  pdfTemplate,
  socialBoost,
  systemClients,
  memberships,
  settablePermissions,
  assignedMembership,
  assignedPermissions,
  blockedPermissions,
  permissionLookup,
  cloudEvents,
  assignmentOptions,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
